var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    {
      ref: "modal",
      attrs: { size: "large", dialogStyleOpt: "stickyTop", closable: true },
      on: { open: _vm.openHandler },
    },
    [
      _c("div", { staticClass: "submission-email-subject" }, [
        _c("label", [_vm._v(_vm._s(_vm.$t("eCircular.subject")))]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("tenantProjects.postFitout.titleWithNumber", [
                  _vm.currentSubmission.order
                    ? _vm.currentSubmission.order + 1
                    : "",
                ]) +
                  " - " +
                  _vm.currentTenantProject.projectName
              ) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.canSend ? _c("EmailEditFields") : _vm._e(),
      _vm._v(" "),
      _c("CommentsPreviewBody", {
        attrs: { isBatchesView: false, activeBatch: _vm.activeBatch },
      }),
      _vm._v(" "),
      _c("TenantSubmissionDocuments", {
        attrs: {
          files: _vm.files,
          sourceId: (_vm.currentSubmission || {}).id || "",
          canEdit: false,
        },
        on: {
          "update:files": function ($event) {
            _vm.files = $event
          },
        },
      }),
      _vm._v(" "),
      _vm.canSend
        ? _c(
            "div",
            { staticClass: "row align-right nav_btn" },
            [
              _c("HKLButton", {
                directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                attrs: { color: "darkblue", action: "save" },
                on: {
                  click: function ($event) {
                    return _vm.saveReceivers()
                  },
                },
              }),
              _vm._v(" "),
              _c("HKLButton", {
                directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                attrs: {
                  color: "orange",
                  action: _vm.hasSend ? "resend" : "send",
                },
                on: {
                  click: function ($event) {
                    return _vm.sendReceivers()
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("PostFitOutCommentHistory"),
      _vm._v(" "),
      _c("PostFitOutReviewerHistory"),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [_c("div")]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }